
const _ = require('lodash');

import ko from 'rgs-knockout';
const kv = require('knockout.validation');

const $ = require('jquery');


function findAndSelf (selector, ctx) {
	return $(ctx).find(selector).addBack(selector);
}

kv.validationFinders = {
	dataValidationHint: {
		groups: function (ctx) {
			return findAndSelf('[data-validation-hint="group"]', ctx);
		},
		label: function (group) {
			return $('[data-validation-hint="label"]', group)[0];
		},
		controls: function (group) {
			return $('[data-validation-hint="control"]', group);
		},
		afterMessage: function (group) {
			return $('[data-validation-hint="afterMessage"]', group)[0];
		},
	},
	bootstrapClass: {
		groups: function (ctx) {
			return findAndSelf('.form-group', ctx);
		},
		label: function (group) {
			return $(group).find('.control-label')[0];
		},
		controls: function (group) {
			return $(group).find('.form-control');
		},
		afterMessage: function (group) {
			return $(group)
				.find('.form-control')
				.first()
				.closest('.form-group > *');
		},
	},
};

const bindingProvider = ko.bindingProvider.instance;

kv.validatedBindingsFinders = (function () {
	function valueBindingFinder (bindingName) {
		return {
			nodeHasValidatedBinding: function (node) {
				return this.getValidatedObservablesAccessor(node);
			},
			getValidatedObservablesAccessor: function (node) {
				const ctx = ko.contextFor(node);
				const bindingAccessors
						= ctx && bindingProvider.getBindingAccessors(node, ctx);
				return bindingAccessors && bindingAccessors[bindingName];
			},
		};
	}

	return {
		explicit: valueBindingFinder('validationValue'),
		value: valueBindingFinder('value'),
		checked: valueBindingFinder('checked'),
		valueSelectButtonGroup: {
			nodeHasValidatedBinding: function (node) {
				return this.getValidatedObservablesAccessor(node);
			},
			getValidatedObservablesAccessor: function (node) {
				const ctx = ko.contextFor(node);
				const bindingAccessors
						= ctx && bindingProvider.getBindingAccessors(node, ctx);
				return bindingAccessors && bindingAccessors.valueSelectButtonGroup && function () {
					const opts = bindingAccessors.valueSelectButtonGroup();
					return opts.observable;
				};
			},
		},
	};
}());

kv.findAllValidatedObservablesAccessors = function (node) {
	const validatedObservablesAccessors = [];
	_.each(kv.validatedBindingsFinders, function (bFinder) {
		if (bFinder.nodeHasValidatedBinding(node)) {
			validatedObservablesAccessors.push(
				bFinder.getValidatedObservablesAccessor(node)
			);
		}
	});
	return validatedObservablesAccessors;
};

const highlightBindingAppliedTag
	  = 'knockout.validation.extensions.highlightBindingApplied';
const groupMessageBindingAppliedTag
	  = 'knockout.validation.extensions.groupMessageBindingAppliedTag';

kv.applyMessagePlacementBindings = function (ctx, options) {
	options = _.defaults({}, options, {
		showGroupMessages: true,
		highlightControls: true,
	});

	_.each(kv.validationFinders, function (vFinder) {
		const groups = vFinder.groups(ctx);
		_.map(groups, function (group) {
			if ($(group).closest('[data-validation-hint="escape"]', ctx)[0]) {
				return;
			}

			function nodeHasBindingsFilter (i, node) {
				return bindingProvider.nodeHasBindings(node);
			}

			function nodeHasEscapeUnderGroupHint (i, node) {
				return !$(node).closest('[data-validation-hint="escape"]', group)[0];
			}

			// Find all the element of interest in the group
			const controls = vFinder.controls(group);
			const label = vFinder.label(group);
			let afterMessage = vFinder.afterMessage(group);

			// Fallback to default `afterMessage` value
			if (!$(afterMessage).length) {
				if ($(controls)[0]) {
					afterMessage = $(controls).first();
				} else if ($(label)[0]) {
					afterMessage = $(label).next();
				} else {
					afterMessage = $(group).children().first();
				}
			}

			//#region Bind controls highlight/unhighlight
			if (options.highlightControls) {
				const controlsWithBindings = controls
					.filter(nodeHasBindingsFilter)
					.filter(nodeHasEscapeUnderGroupHint);

				controlsWithBindings.each(function (i, control) {
					// collection of all validated binding accessors from this control
					const controlValidatedObservablesAccessors
							= kv.findAllValidatedObservablesAccessors(control);

					if (controlValidatedObservablesAccessors.length
						&& !ko.utils.domData.get(control, highlightBindingAppliedTag)
					) {
						ko.utils.domData.set(control, highlightBindingAppliedTag, true);
						ko.applyBindingAccessorsToNode(control, {
							validationControlHighlightForObservables: function () {
								let validatedObservables = [];
								_.map(controlValidatedObservablesAccessors, function (v) {
									v = v();
									validatedObservables = validatedObservables.concat(v);
								});
								return {
									validated: validatedObservables,
								};
							},
						}, ko.contextFor(control));
					}
				});
			}
			//#endregion

			//#region Bind error placement/removal
			if (options.showGroupMessages) {
				const descendantsWithBindings = $(group)
						.find('*')
						.andSelf()
						.filter(nodeHasBindingsFilter)
						.filter(nodeHasEscapeUnderGroupHint);

				let groupValidatedObservablesAccessors = [];

				descendantsWithBindings.each(function (i, group) {
					groupValidatedObservablesAccessors = groupValidatedObservablesAccessors.concat(
						kv.findAllValidatedObservablesAccessors(group)
					);
				});

				if (groupValidatedObservablesAccessors.length
					&& !ko.utils.domData.get(group, groupMessageBindingAppliedTag)
				) {
					ko.utils.domData.set(group, groupMessageBindingAppliedTag, true);
					ko.applyBindingAccessorsToNode(group, {
						validationGroupMessageForObservables: function () {
							const validatedObservables = _.flatMap(
								groupValidatedObservablesAccessors,
								accessor => accessor()
							);
							return {
								validated: validatedObservables,
								messageAnimatorLabel: label,
								messageAnimatorInsertBefore: afterMessage,
							};
						},
					}, ko.contextFor(group));
				}
			}
			//#endregion
		});
	});
};

// TODO: The right way to apply message placement is in a custom bindings provider
ko.bindingHandlers.validationApplyMessagePlacement = {
	after: ['with', 'foreach', 'validationContext'],

	init: function (element, valueAccessor) {
		const options = (() => {
			let options = valueAccessor();
			if (options === 'delay') {
				console.error(
					"`validationApplyMessagePlacement: 'delay'` usage is deprecated.",
					"Validatation bindings are now delayed by default.",
					"Please remove the `'delay'` argument.",
					"Offending element: ", element,
				);
				throw new Error(
					'Deprecated `validationApplyMessagePlacement` usage, see warning above'
				);
			}
			return _.defaults({}, options, {
				delay: true,
			});
		})();

		if (options.delay) {
			setTimeout(function () {
				kv.applyMessagePlacementBindings(element, options);
			}, 0);
		} else {
			kv.applyMessagePlacementBindings(element, options);
		}
	},

	update: function (element, valueAccessor, allBindings) {
		// Apply message placement when children are updated by theese special bindings
		ko.unwrap(allBindings.get('with'));
		ko.unwrap(allBindings.get('foreach'));
		ko.bindingHandlers.validationApplyMessagePlacement.init(...arguments);
	},
};
